/* tslint:disable */
/* eslint-disable */
/**
 * Localingos API
 * Developer-first automated localization platform powered by AI. Sync your project and continuously localize only what changed.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AdminUserDto } from '../models';
// @ts-ignore
import type { UserDto } from '../models';
// @ts-ignore
import type { UserGroupManagementDto } from '../models';
/**
 * UserManagementApi - axios parameter creator
 * @export
 */
export const UserManagementApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Check if the current authenticated user has admin privileges.
         * @summary Check current user admin status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserAdminStatus: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/current/admin-status`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get the groups that a specific user belongs to. Only accessible by admin users.
         * @summary Get user groups
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroups: async (username: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'username' is not null or undefined
            assertParamExists('getUserGroups', 'username', username)
            const localVarPath = `/api/users/{username}/groups`
                .replace(`{${"username"}}`, encodeURIComponent(String(username)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Get a list of all users in the Cognito User Pool. Only accessible by admin users.
         * @summary List all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Admin-only. Returns users enriched with plan, usage, and project info.
         * @summary List all users with billing and project data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEnrichedUsers: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/users/admin/enriched`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Add or remove a user from a group. Only accessible by admin users.
         * @summary Manage user group membership
         * @param {UserGroupManagementDto} userGroupManagementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageUserGroup: async (userGroupManagementDto: UserGroupManagementDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'userGroupManagementDto' is not null or undefined
            assertParamExists('manageUserGroup', 'userGroupManagementDto', userGroupManagementDto)
            const localVarPath = `/api/users/manage-group`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(userGroupManagementDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * UserManagementApi - functional programming interface
 * @export
 */
export const UserManagementApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = UserManagementApiAxiosParamCreator(configuration)
    return {
        /**
         * Check if the current authenticated user has admin privileges.
         * @summary Check current user admin status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCurrentUserAdminStatus(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCurrentUserAdminStatus(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.getCurrentUserAdminStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get the groups that a specific user belongs to. Only accessible by admin users.
         * @summary Get user groups
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUserGroups(username: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<string>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUserGroups(username, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.getUserGroups']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Get a list of all users in the Cognito User Pool. Only accessible by admin users.
         * @summary List all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listAllUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<UserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listAllUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.listAllUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Admin-only. Returns users enriched with plan, usage, and project info.
         * @summary List all users with billing and project data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async listEnrichedUsers(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<AdminUserDto>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.listEnrichedUsers(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.listEnrichedUsers']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Add or remove a user from a group. Only accessible by admin users.
         * @summary Manage user group membership
         * @param {UserGroupManagementDto} userGroupManagementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async manageUserGroup(userGroupManagementDto: UserGroupManagementDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.manageUserGroup(userGroupManagementDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['UserManagementApi.manageUserGroup']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * UserManagementApi - factory interface
 * @export
 */
export const UserManagementApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = UserManagementApiFp(configuration)
    return {
        /**
         * Check if the current authenticated user has admin privileges.
         * @summary Check current user admin status
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCurrentUserAdminStatus(options?: RawAxiosRequestConfig): AxiosPromise<boolean> {
            return localVarFp.getCurrentUserAdminStatus(options).then((request) => request(axios, basePath));
        },
        /**
         * Get the groups that a specific user belongs to. Only accessible by admin users.
         * @summary Get user groups
         * @param {string} username 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUserGroups(username: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<string>> {
            return localVarFp.getUserGroups(username, options).then((request) => request(axios, basePath));
        },
        /**
         * Get a list of all users in the Cognito User Pool. Only accessible by admin users.
         * @summary List all users
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listAllUsers(options?: RawAxiosRequestConfig): AxiosPromise<Array<UserDto>> {
            return localVarFp.listAllUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * Admin-only. Returns users enriched with plan, usage, and project info.
         * @summary List all users with billing and project data
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        listEnrichedUsers(options?: RawAxiosRequestConfig): AxiosPromise<Array<AdminUserDto>> {
            return localVarFp.listEnrichedUsers(options).then((request) => request(axios, basePath));
        },
        /**
         * Add or remove a user from a group. Only accessible by admin users.
         * @summary Manage user group membership
         * @param {UserGroupManagementDto} userGroupManagementDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        manageUserGroup(userGroupManagementDto: UserGroupManagementDto, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.manageUserGroup(userGroupManagementDto, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * UserManagementApi - object-oriented interface
 * @export
 * @class UserManagementApi
 * @extends {BaseAPI}
 */
export class UserManagementApi extends BaseAPI {
    /**
     * Check if the current authenticated user has admin privileges.
     * @summary Check current user admin status
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public getCurrentUserAdminStatus(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).getCurrentUserAdminStatus(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get the groups that a specific user belongs to. Only accessible by admin users.
     * @summary Get user groups
     * @param {string} username 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public getUserGroups(username: string, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).getUserGroups(username, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Get a list of all users in the Cognito User Pool. Only accessible by admin users.
     * @summary List all users
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public listAllUsers(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).listAllUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Admin-only. Returns users enriched with plan, usage, and project info.
     * @summary List all users with billing and project data
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public listEnrichedUsers(options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).listEnrichedUsers(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Add or remove a user from a group. Only accessible by admin users.
     * @summary Manage user group membership
     * @param {UserGroupManagementDto} userGroupManagementDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserManagementApi
     */
    public manageUserGroup(userGroupManagementDto: UserGroupManagementDto, options?: RawAxiosRequestConfig) {
        return UserManagementApiFp(this.configuration).manageUserGroup(userGroupManagementDto, options).then((request) => request(this.axios, this.basePath));
    }
}

